export default __webpack_public_path__ + "static/oops-ce523bc4aa0f03b86f43d7346065ee1d.png";